import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LabelLift from "../UI/LabelLift";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";

const Lift13 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift13"
			 className={getLiftClass(isOpen, activeLiftId === '13', state)}
			 transform="translate(1805.000000, 1132.000000)"
		>
			<path
				d="M58,12.9335938 L44,158 L13,374" id="Line" stroke={colors[0]} strokeWidth="3"
				strokeLinecap="round" strokeDasharray="6"
				className="animated"
			/>

			<LabelLift isOpen={isOpen} text={<tspan x="-3" y="13">13</tspan>} coords={'0.000000, 361.000000'} state={state}/>
			<LiftLabelTypeSeat seatCount="4" colors={getLiftStatusColors(state, isOpen)} coords="23.000000, 170.000000" isOpen={isOpen}/>

			<g transform="translate(45.000000, 0.000000)">
				<circle fill={colors[1]} cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" cx="13" cy="13" r="10"/>
			</g>

			<polygon
				fill={colors[2]}
				transform="translate(57.500000, 14.500000) scale(-1, 1) rotate(-94.000000) translate(-57.500000, -14.500000) "
				points="52 14.5 63 9 60.6285127 14.5 63 20"/>
		</g>
	);
};


Lift13.propTypes = {};

export default Lift13;
